import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ResultadoPartidos from "./pages/admin/ResultadoPartidos";
import Terminos from "./pages/Terminos";
import PagoExitoso from "./pages/PagoExitoso";
import PagoFallido from "./pages/PagoFallido";
import PagoPendiente from "./pages/pagoPendiente";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />    
      <Route path="/terminos" element={<Terminos />} />      
      <Route path="/admin/liquidar-partido" element={<ResultadoPartidos />} />
      <Route path="/success" element={<PagoExitoso />} />
      <Route path="/failure" element={<PagoFallido />} />
    <Route path="/pending" element={<PagoPendiente />} />
      
    </Routes>
  );
}



export default App;

  